import React from 'react'
import { Trans } from '@lingui/macro'
import { ButtonLight } from 'front-end/src/components'
import IconPeople from '../../icon/IconPeople'
import { useMembersSelectorContext } from '../MembersSelectorContext'
import { Center } from '@chakra-ui/react'
import { observer } from 'mobx-react-lite'

export const AddressBook: React.FC = observer(() => {
  const { isAddressBookActive, setShowAddressBook } =
    useMembersSelectorContext()

  return (
    <>
      <span className="or">
        <Trans>or</Trans>
      </span>
      <ButtonLight
        accessibilityTitle="Groups"
        iconOnly
        isActive={isAddressBookActive}
        onClick={() => setShowAddressBook(!isAddressBookActive)}
      >
        <Center>
          <IconPeople />
        </Center>
      </ButtonLight>
    </>
  )
})
